fragment TextImage on textImage_MatrixField {
    ... on textImageBlock_Entry {
        title: blockTitle
        text: richTextContent {
            html
        }
        image {
            url
            width
            height
            w1858: url @transform(format: "webp", width: 1858)
            w1858_avif: url @transform(format: "avif", width: 1858)
            w929: url @transform(format: "webp", width: 929) #landscape
            w929_avif: url @transform(format: "avif", width: 929) #landscape
            w660: url @transform(format: "webp", width: 660)
            w660_avif: url @transform(format: "avif", width: 660)
            w480: url @transform(format: "webp", width: 480)
            w480_avif: url @transform(format: "avif", width: 480)
            w320: url @transform(format: "webp", width: 320)
            w320_avif: url @transform(format: "avif", width: 320)
        }
        backgroundColor
    }
}
